"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedLocales = exports.getLocaleLangMatch = exports.getLanguageOptions = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var supportedLocales = ['en_US', 'zh_CN', 'ja_JP', 'ko_KR', 'zh_TW', 'es_MX', 'pt_BR', 'cs_CZ', 'da_DK', 'de_DE', 'es_ES', 'fr_FR', 'it_IT', 'hu_HU', 'nl_NL', 'nb_NO', 'pl_PL', 'pt_PT', 'fi_FI', 'sv_SE', 'ru_RU', 'en_GB', 'tr_TR', 'fr_CA', 'en_MY', 'en_HK', 'en_SG', 'en_NL', 'en_AE', 'en_ZA', 'en_CA', 'en_AU', 'en_IN', 'en_NZ', 'fr_BE', 'fr_CH', 'de_CH', 'es_LA', 'it_CH', 'nl_BE'];

/*
 * Generates locales / plural mapping
 * Locales eg. {en_US: en, es_MX: es, zn_TW: zn}
 */
exports.supportedLocales = supportedLocales;
var getLocaleLangMatch = function getLocaleLangMatch() {
  var locales = {};
  supportedLocales.forEach(function (loc) {
    if (loc.indexOf('_') === 2) {
      locales[loc] = loc.slice(0, 2);
    }
  });
  return locales;
};

/*
 * Language options for storybook select
 */
exports.getLocaleLangMatch = getLocaleLangMatch;
var getLanguageOptions = function getLanguageOptions() {
  var languageOptions = [];
  languageOptions = supportedLocales.map(function (loc) {
    return loc.replace('_', '-');
  });
  return languageOptions;
};
exports.getLanguageOptions = getLanguageOptions;